<template>
  <th
    scope="col"
    class="text-neutral-0 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
    :class="rightAligned && 'text-right'"
  >
    <slot></slot>
  </th>
</template>

<script>
export default {
  name: "SimpleTableHeader",
  props: {
    rightAligned: { type: Boolean, default: false },
  },
};
</script>
